export default class MaillageFormationsIntervenant {
  constructor() {
    this.container = document.querySelector('.maillage-formations-intervenant');
    if (!this.container) return;

    this.listContainer = this.container.querySelector('#intervenantProductList');
    this.intervenantId = this.container.dataset.intervenantId;
    this.ajaxurl = this.container.dataset.ajaxurl || maillageFormationsIntervenant.ajaxurl;

    this.init();
  }

  init() {
    if (!this.intervenantId) {
      this.displayNull();
      return;
    }
    this.fetchRelatedProducts();
  }

  async fetchRelatedProducts() {
    const formData = new FormData();
    formData.append('action', 'get_products_from_main_site_intervenant');
    formData.append('current_intervenant_id', this.intervenantId);

    try {
      const response = await fetch(this.ajaxurl, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.success && data.data.length > 0) {
        this.displayProducts(data.data);
      } else {
        this.displayNull();
        console.warn(data.data?.message || 'Erreur inconnue ou aucune donnée');
      }
    } catch (error) {
      this.displayNull();
      console.error('Erreur lors de la récupération des produits :', error);
    }
  }

  displayProducts(products) {
    if (!this.listContainer || !products.length) {
      this.displayNull();
      return;
    }

    // Affiche le container si des produits sont présents
    this.container.style.display = 'block';

    this.listContainer.innerHTML = products.map(product => {
      const thematiques = product.thematique.map(t => {
        const name = t.name || '';
        return `<span class="thematique">${name}</span>`;
      }).join(', ');

      const qualifications = product.qualification.map(q => {
        const color = q.color || '#f0f0f0';
        const name = q.name || '';
        return `
          <div class="tag" style="background-color: ${color}">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" fill="none">
              <path fill="#1A1F2F" d="M12 9.75V.25L0 9.75h12Z"></path>
            </svg> ${name}
          </div>
        `;
      }).join('');

      return `
        <div class="swiper-slide">
          <div class="product-item">
            <div class="card card-formation">
              <div class="qualif default">
                ${qualifications}
              </div>
              <div class="card-content">
                <div class="card-content-info">
                  <div>
                    <h3 class="title">
                      <a href="${product.permalink}" target="_blank">${product.title}</a>
                    </h3>
                    <div class="product-thematiques">${thematiques}</div>
                  </div>
                  <div>
                    <a href="${product.permalink}" target="_blank" class="btn btn-dark"><span class="label">Découvrir la formation</span><svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" fill="none"><path stroke="#fff" stroke-width="1.5" d="m1 8 3.5-3.5L1 1"/></svg></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  displayNull() {
    if (this.container) {
      this.container.remove();
    }
  }
}
